import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import Button from "../../../components/ui/Button";
import Text from "../../../components/ui/Text";
import { DESKTOP_LAYOUTS } from "../../../constants/spacing";

export const GameHistory = ({ gameHistoryCount }) => {
  return (
    <Box sx={DESKTOP_LAYOUTS.contentCard}>
      <Text variant="paragraph" sx={{ fontSize: "20px", mb: 3 }}>
        Game history
      </Text>
      {gameHistoryCount > 0 ? (
        <Button
          component={Link}
          to="/game-history"
          variant="outlined"
          sx={{
            mt: 2,
            width: "100%",
            color: "#666",
            borderColor: "#E5E5E5",
            backgroundColor: "white",
            "&:hover": {
              backgroundColor: "#F9F9F9",
              borderColor: "#D0D0D0",
            },
          }}
        >
          View
        </Button>
      ) : (
        <Text
          variant="body2"
          sx={{ textAlign: "center", py: 2, color: "#666" }}
        >
          No past games.
        </Text>
      )}
    </Box>
  );
};
